import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionHeading } from "@/components/SectionHeading";
import { APPROACH } from "@/data/content";

const StackCard = ({ a, i, total }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  // previous cards shrink slightly as the next one slides over them
  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.9]);
  const isLast = i === total - 1;

  return (
    <div
      ref={ref}
      className="sticky"
      style={{ top: `calc(7rem + ${i * 1.6}rem)` }}
    >
      <motion.div
        style={{ scale: isLast ? 1 : scale }}
        className="relative overflow-hidden rounded-[1.6rem] border border-brand-ink/10 p-8 md:p-14 shadow-[0_24px_70px_-40px_rgba(20,102,214,0.45)]"
      >
        <div
          className="absolute inset-0 -z-10"
          style={{ background: `linear-gradient(135deg, #FFFFFF 0%, #EEF5FF 60%, #E3EEFF 100%)` }}
        />
        <div
          className="pointer-events-none absolute -right-24 -top-24 h-64 w-64 rounded-full opacity-50 blur-3xl"
          style={{ background: "radial-gradient(circle, #7CC4FF, transparent 70%)" }}
        />
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:gap-14">
          <div className="font-display font-black leading-none tracking-tighter text-transparent [-webkit-text-stroke:1.5px_rgba(20,102,214,0.35)] text-7xl md:text-[10rem]">
            {a.phase}
          </div>
          <div className="flex-1">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-primary">
              Phase {a.phase}
            </span>
            <h3 className="mt-3 font-heading font-black tracking-tight text-3xl md:text-6xl text-brand-ink">
              {a.title}
            </h3>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-brand-ink/75">{a.text}</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export const ApproachStack = () => (
  <section className="relative noise-overlay" data-testid="approach-section">
    <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 pt-14 md:pt-24">
      <SectionHeading label="05 — How we work" title="A focused process, from insight to impact." />
    </div>
    <div className="relative z-10 mx-auto max-w-[1200px] px-6 md:px-12 pb-16 md:pb-28">
      <div className="mt-14 flex flex-col gap-6 md:gap-10">
        {APPROACH.map((a, i) => (
          <StackCard key={a.phase} a={a} i={i} total={APPROACH.length} />
        ))}
      </div>
    </div>
  </section>
);
